import { setAuthCookies } from "../index";
import { checkAccess } from "./constants";
import { getParsedToken } from "../../components/utils";
import { call, put, takeLatest } from "redux-saga/effects";
import { USERPOSITIONS } from "../../constants/userPositions";
import { auth, getCurrentUser, getRefreshToken } from "./dSystemAPI";
import {
  getRole,
  AvailableRoles,
  RolesWithAccessFromLoginPage,
} from "../../constants/roles";
import {
  authAC,
  logoutAC,
  authSagaAC,
  authErrorAC,
  authLoaderAC,
  logoutSagaAC,
  refreshTokensSagaAC,
  forgotPasswordSagaAC,
  setCurrentUserInfoAC,
  setCurrentUserInfoSagaAC,
} from "./systemActionCreators";

export function* authWorker(actionObject: {
  type: string;
  payload: { email: string; password: string; rememberChecked: boolean };
}) {
  yield put(authLoaderAC(true));
  const requestObject = {
    email: actionObject.payload.email,
    password: actionObject.payload.password,
  };
  const response = yield call(auth, requestObject);

  if (response.status === 200) {
    // check for access from login page
    const role = getRole(
      getParsedToken(response.data.access_token).realm_access.roles,
    );

    if (role && RolesWithAccessFromLoginPage.includes(role)) {
      const responseUser = yield call(
        getCurrentUser,
        response.data.access_token,
      );

      if (responseUser.status === 200) {
        // check access by role && position
        const role = getRole(responseUser.data.authorizedUser.roles);
        // super admin has position: null
        const position = responseUser.data.position
          ? responseUser.data.position
          : role === AvailableRoles.ROLE_TINDA_SUPER_ADMIN ||
              role === AvailableRoles.ROLE_TINDA_ADMIN
            ? USERPOSITIONS.ADMIN
            : null;
        if (checkAccess(role, position)) {
          yield put(
            setCurrentUserInfoAC({ ...responseUser.data, position: position }),
          );

          // set other fields
          const expAccessToken =
            Math.floor(Date.now() * 0.001) + response.data.expires_in;
          const expRefreshToken =
            Math.floor(Date.now() * 0.001) + response.data.refresh_expires_in;

          yield put(authAC(actionObject.payload.email));
          const toLocalData = {
            accessToken: response.data.access_token,
            refreshToken: response.data.refresh_token,
            expAccessToken: expAccessToken,
            expRefreshToken: expRefreshToken,
          };

          localStorage.setItem("authData", JSON.stringify(toLocalData));
          localStorage.setItem("login", JSON.stringify(requestObject.email));

          document.cookie = `to=${requestObject.email}; path=/; domain=${process.env.REACT_APP_DOMAIN}; max-age=2592000`;

          if (actionObject.payload.rememberChecked) {
            document.cookie = `tindaRememberMeLogin=${requestObject.email}; path=/; domain=${process.env.REACT_APP_DOMAIN}; max-age=2592000`;
          }

          document.cookie = `to=${requestObject.email}; path=/; domain=${process.env.REACT_APP_DOMAIN}; max-age=2592000`;
          //setAuthCookies(`Bearer ${ response.data.access_token }`, response.data.refresh_token)

          yield put(authErrorAC(false));
        } else {
          yield put(authErrorAC(true));
        }
      } else {
        yield put(authErrorAC(true));
        //   yield  put(logoutSagaAC())
      }
    } else {
      yield put(authErrorAC(true));
    }
  } else {
    yield put(authErrorAC(true));
  }

  yield put(authLoaderAC(false));
}

export function* authWatcher() {
  yield takeLatest(authSagaAC.type, authWorker);
}

export function* refreshTokenWorker(actionObject: {
  type: string;
  payload: { refreshToken: string };
}) {
  localStorage.removeItem("authData");

  const response = yield call(getRefreshToken, {
    refreshToken: actionObject.payload.refreshToken,
  });

  if (response.status === 200) {
    // check for access from login page
    const role = getRole(
      getParsedToken(response.data.access_token).realm_access.roles,
    );

    if (role && RolesWithAccessFromLoginPage.includes(role)) {
      // get current user inf0  - for remote control no refresh
      const responseUser = yield call(
        getCurrentUser,
        response.data.access_token,
      );

      if (responseUser.status === 200) {
        // check access by role && position
        const role = getRole(responseUser.data.authorizedUser.roles);
        // super admin has position: null
        const position = responseUser.data.position
          ? responseUser.data.position
          : role === AvailableRoles.ROLE_TINDA_SUPER_ADMIN ||
              role === AvailableRoles.ROLE_TINDA_ADMIN
            ? USERPOSITIONS.ADMIN
            : null;

        if (checkAccess(role, position)) {
          yield put(
            setCurrentUserInfoAC({ ...responseUser.data, position: position }),
          );

          // set other fields

          const expAccessToken =
            Math.floor(Date.now() * 0.001) + response.data.expires_in;
          const expRefreshToken =
            Math.floor(Date.now() * 0.001) + response.data.refresh_expires_in;

          const toLocalData = {
            accessToken: response.data.access_token,
            refreshToken: response.data.refresh_token,
            expAccessToken: expAccessToken,
            expRefreshToken: expRefreshToken,
          };

          localStorage.setItem("authData", JSON.stringify(toLocalData));

          setAuthCookies(
            `Bearer ${response.data.access_token}`,
            response.data.refresh_token,
          );
        } else {
          yield put(authErrorAC(true));
          yield put(logoutSagaAC());
        }
      } else {
        yield put(authErrorAC(true));
        yield put(logoutSagaAC());
      }
    } else {
      yield put(authErrorAC(true));
      yield put(logoutSagaAC());
    }
  } else {
    yield put(authErrorAC(true));
    yield put(logoutSagaAC());
  }
  yield put(authLoaderAC(false));
}

export function* refreshTokenWatcher() {
  yield takeLatest(refreshTokensSagaAC.type, refreshTokenWorker);
}

export function* logoutWorker() {
  localStorage.removeItem("authData");
  localStorage.removeItem("login");

  yield put(authLoaderAC(true));

  yield put(logoutAC());

  yield put(authLoaderAC(false));
}

export function* logoutWatcher() {
  yield takeLatest(logoutSagaAC.type, logoutWorker);
}

export function* forgotPasswordWorker() {
  // TODO: server get data
}

export function* forgotPasswordWatcher() {
  yield takeLatest(forgotPasswordSagaAC.type, forgotPasswordWorker);
}

export function* setCurrentUserInfoWorker(actionObject: {
  type: string;
  payload: { token: string };
}) {
  const responseUser = yield call(getCurrentUser, actionObject.payload.token);

  if (responseUser.status === 200) {
    // check access by role && position
    const role = getRole(responseUser.data.authorizedUser.roles);
    // super admin has position: null
    const position = responseUser.data.position
      ? responseUser.data.position
      : role === AvailableRoles.ROLE_TINDA_SUPER_ADMIN ||
          role === AvailableRoles.ROLE_TINDA_ADMIN
        ? USERPOSITIONS.ADMIN
        : null;
    if (checkAccess(role, position)) {
      yield put(
        setCurrentUserInfoAC({ ...responseUser.data, position: position }),
      );
    } else {
      yield put(authErrorAC(true));
      yield put(logoutSagaAC());
    }
  } else {
    yield put(authErrorAC(true));
    yield put(logoutSagaAC());
  }
}

export function* setCurrentUserInfoWatcher() {
  yield takeLatest(setCurrentUserInfoSagaAC.type, setCurrentUserInfoWorker);
}
